import {
  mdiMonitorDashboard,
  mdiCalendarMonthOutline,
  mdiCalendarTextOutline,
  mdiCalendarStar
} from "@mdi/js";

export const sidebarItems = [
  {
    title: "Noticeboard",
    icon: mdiMonitorDashboard,
    to: { name: "noticeboard" }
  },
  {
    title: "Calendar & Events",
    icon: mdiCalendarMonthOutline,
    children: [
      {
        title: "Calendar",
        icon: mdiCalendarTextOutline,
        to: { name: "user-calendar" }
      },
      {
        title: "Events",
        icon: mdiCalendarStar,
        to: { name: "user-events" }
      }
    ]
  }
];
